export const FACTORIAL_CREATION_YEAR = 2016
